/* Product page and browsing requests to PIM's cart-estimate go through here: the header,
 * the product page badge, the one line <aps-when> cards, and PIM's own In Your Hands
 * module on the product page. The cart page and the cart promise sync do not; they ask
 * PIM directly, exactly as they always have.
 *
 * One answer per question. A question is the channel, the SKUs and the zip. A request
 * already in flight is joined, and a good answer is kept for five minutes or until its
 * order-by cutoff, whichever is first, in session storage so the next page can use it
 * too. A cached answer has its order_in counted down to now, so a countdown or a cutoff
 * timer read from it stays exact. A failed or refused answer (a 429, a timeout) is never
 * kept and resolves null, which is what every caller already treats as no answer.
 *
 * PIM's module posts through its own XMLHttpRequest and exposes no hook, so a narrow
 * wrapper watches its request and shares its answer here, so the badge beside it does
 * not ask the same question again. It reads a POST to this exact URL and nothing else,
 * and sends the module's request exactly as the module wrote it.
 *
 * A shopper id is built but OFF. PIM keeps one routing row per reference_id and clears
 * and refills its SKUs on every request, so requests that share an id and overlap would
 * read each other's SKUs back (ModelRoutingService::routeCart). Until PIM handles that,
 * no request carries an id. SEND_ID turns it on: a random value saved for the shopper
 * plus a short hash of the question, added to the theme's requests and the module's.
 * PIM bot load, 2026-10-29.
 */
(function () {
  var ENDPOINT = 'https://pim.poolzoom.com/api/routing/cart-estimate';
  var SEND_ID = false;
  var ID_KEY = 'apsEstimateId';
  var CACHE_KEY = 'apsEstimates';
  var TTL = 5 * 60000;
  var MAX_KEPT = 40;
  var inflight = {};
  var waiters = {};
  var memory = {};
  var sessionId = null;

  function randomId() {
    var c = window.crypto;
    try { if (c && c.randomUUID) return c.randomUUID(); } catch (e) {}
    var bytes = new Uint8Array(16);
    try { c.getRandomValues(bytes); } catch (e) {
      for (var i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
    }
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    var hex = '';
    for (var j = 0; j < 16; j++) hex += (bytes[j] < 16 ? '0' : '') + bytes[j].toString(16);
    return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
  }

  /* Saved once per shopper. Storage refused means one id for this page, which is
     still one row per question rather than one per request. */
  function shopperId() {
    if (sessionId) return sessionId;
    try { sessionId = localStorage.getItem(ID_KEY); } catch (e) {}
    if (!sessionId || !/^[0-9a-f-]{36}$/.test(sessionId)) {
      sessionId = randomId();
      try { localStorage.setItem(ID_KEY, sessionId); } catch (e) {}
    }
    return sessionId;
  }

  /* channel|zip|sku:qty,sku:qty, the same for the theme's bodies and the module's. */
  function keyOf(body) {
    var cart = (body && body.cart) || {};
    var lines = Object.keys(cart).sort().map(function (sku) { return sku + ':' + cart[sku]; });
    return (Number(body && body.channel) || 0) + '|' + ((body && body.zip) || '') + '|' + lines.join(',');
  }

  function hash(text) {
    var h = 0x811c9dc5;
    for (var i = 0; i < text.length; i++) {
      h ^= text.charCodeAt(i);
      h = Math.imul(h, 0x01000193) >>> 0;
    }
    return ('0000000' + h.toString(16)).slice(-8);
  }

  function idFor(key) { return shopperId() + '-' + hash(key); }

  /* Session storage when it works, this page's memory when it does not. */
  var stored = true;
  function load() {
    var map = memory;
    if (stored) {
      try { map = JSON.parse(sessionStorage.getItem(CACHE_KEY)) || {}; } catch (e) { stored = false; map = memory; }
    }
    return map && typeof map === 'object' ? map : {};
  }
  function save(map) {
    memory = map;
    if (!stored) return;
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(map)); } catch (e) { stored = false; }
  }

  /* When PIM's order_in runs out, as an instant, or null. Same reading as cutoffAt below. */
  function cutoffOf(data, at) {
    var o = data && data.order_in;
    if (!o || typeof o.hours !== 'number') return null;
    var ms = (o.hours * 60 + (o.minutes || 0)) * 60000;
    if (ms <= 0 || ms > 36 * 3600000) return null;
    return at + ms;
  }

  function remember(key, data) {
    if (!data || typeof data !== 'object') return;
    var now = Date.now();
    var cutoff = cutoffOf(data, now);
    var map = load();
    Object.keys(map).forEach(function (k) { if (!map[k] || map[k].until <= now) delete map[k]; });
    map[key] = { data: data, until: cutoff ? Math.min(now + TTL, cutoff) : now + TTL, cutoff: cutoff };
    var keys = Object.keys(map);
    if (keys.length > MAX_KEPT) {
      keys.sort(function (a, b) { return map[a].until - map[b].until; });
      keys.slice(0, keys.length - MAX_KEPT).forEach(function (k) { delete map[k]; });
    }
    save(map);
  }

  /* A copy, so no caller can change another's answer, with order_in counted to now. */
  function recall(key) {
    var entry = load()[key];
    if (!entry || !entry.data || entry.until <= Date.now()) return null;
    var data = JSON.parse(JSON.stringify(entry.data));
    if (entry.cutoff) {
      var left = Math.max(0, entry.cutoff - Date.now());
      var minutes = Math.floor(left / 60000);
      data.order_in = { hours: Math.floor(minutes / 60), minutes: minutes % 60 };
    }
    return data;
  }

  function settle(key, promise) {
    inflight[key] = promise;
    (waiters[key] || []).forEach(function (wake) { wake(promise); });
    delete waiters[key];
    promise.then(function (data) {
      if (inflight[key] === promise) delete inflight[key];
      remember(key, data);
    });
    return promise;
  }

  function post(key, body, timeout) {
    var payload = {};
    Object.keys(body).forEach(function (k) { payload[k] = body[k]; });
    if (SEND_ID && !payload.id) payload.id = idFor(key);
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, timeout || 6000) : null;
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: controller ? controller.signal : undefined
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (data) { clearTimeout(timer); return data && typeof data === 'object' ? data : null; });
  }

  /* The one way to ask. Resolves PIM's answer or null, never rejects.
     options.timeout: ms before giving up, default 6000.
     options.peerWait: ms to wait for PIM's module to ask the same question first, so the
     product page badge rides on the module's request instead of making its own. */
  function request(body, options) {
    options = options || {};
    var key = keyOf(body);
    var cached = recall(key);
    if (cached) return Promise.resolve(cached);
    function copy(data) { return data ? (recall(key) || data) : null; }
    if (inflight[key]) return inflight[key].then(copy);
    if (!(options.peerWait > 0)) return settle(key, post(key, body, options.timeout)).then(copy);

    return new Promise(function (resolve) {
      var done = false;
      var list = waiters[key] || (waiters[key] = []);
      function join(promise) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        resolve(promise.then(copy));
      }
      list.push(join);
      var timer = setTimeout(function () {
        if (done) return;
        var i = list.indexOf(join);
        if (i >= 0) list.splice(i, 1);
        join(inflight[key] || settle(key, post(key, body, options.timeout)));
      }, options.peerWait);
    });
  }

  /* PIM's module. Only a POST to the endpoint with a JSON string body is read, and with
     SEND_ID off its body goes out byte for byte as the module wrote it. */
  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype && XHR.prototype.open && XHR.prototype.send) {
    var open = XHR.prototype.open;
    var send = XHR.prototype.send;
    XHR.prototype.open = function (method, url) {
      try {
        this.__apsEstimate = String(method).toUpperCase() === 'POST' &&
          String(url).split('?')[0].replace(/\/+$/, '') === ENDPOINT;
      } catch (e) { this.__apsEstimate = false; }
      return open.apply(this, arguments);
    };
    XHR.prototype.send = function (body) {
      if (this.__apsEstimate && typeof body === 'string') {
        try {
          var parsed = JSON.parse(body);
          if (parsed && typeof parsed === 'object' && parsed.cart) {
            var key = keyOf(parsed);
            if (SEND_ID && !parsed.id) {
              parsed.id = idFor(key);
              body = JSON.stringify(parsed);
            }
            var xhr = this;
            settle(key, new Promise(function (resolve) {
              xhr.addEventListener('loadend', function () {
                var data = null;
                try {
                  if (xhr.status >= 200 && xhr.status < 300) data = JSON.parse(xhr.responseText);
                } catch (e) { data = null; }
                resolve(data && typeof data === 'object' ? data : null);
              });
            }));
          }
        } catch (e) { /* leave the module's request exactly as it was */ }
      }
      return send.call(this, body);
    };
  }

  window.apsEstimate = { request: request, endpoint: ENDPOINT };
})();

/* The shopper's delivery location, shared between the header chip and the PDP panel.
 *
 * The header shows a place, never a date. A date needs a cart, and PIM answers a
 * multi-line cart with a single estimate that collapses to no warehouse at all the
 * moment one line cannot be routed, which today is most of them. A place is always
 * right; see docs/decisions/2026-09-02-pim-in-your-hands.md.
 *
 * Two keys, on purpose. apsDelivery is ours and holds the resolved place so the chip
 * can paint on the first frame with no request at all. inYourHandsZip is PIM's own
 * key, read by its module on mount, so writing it is what keeps the panel and the
 * chip agreeing after either one changes the zip.
 *
 * The event travels one way from whoever changed it. Neither listener re-dispatches,
 * which is what stops the header and the panel talking each other in circles.
 */
(function () {
  var KEY = 'apsDelivery';
  var PIM_KEY = 'inYourHandsZip';
  var EVENT = 'aps:delivery';

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY));
      return raw && raw.city ? raw : null;
    } catch (e) {
      return null;
    }
  }

  function write(value) {
    try {
      localStorage.setItem(KEY, JSON.stringify(value));
      if (value.zip) localStorage.setItem(PIM_KEY, value.zip);
    } catch (e) {
      /* private mode, or storage refused. The value still works for this page. */
    }
  }

  /* An empty cart is deliberate. PIM resolves the destination from the zip, or from
   * the caller's IP when there is none, and returns it whether or not there is
   * anything to ship. That is the whole request the header needs. */
  function resolve(zip, channel) {
    var body = { cart: {}, current: {}, channel: Number(channel) };
    if (zip) body.zip = zip;

    return window.apsEstimate.request(body, { timeout: 4000 })
      .then(function (data) {
        var place = data && data.destination;
        // A zip PIM cannot place comes back with a null city and a real looking
        // everything else, so the city is the only trustworthy signal here.
        if (!place || !place.city || !place.state_abbreviation) return null;
        return {
          zip: String(place.zip || zip || ''),
          city: place.city + ', ' + place.state_abbreviation
        };
      });
  }

  function announce(value) {
    document.dispatchEvent(new CustomEvent(EVENT, { detail: value }));
  }

  window.apsDelivery = {
    read: read,
    resolve: resolve,
    event: EVENT,
    /* Store it and tell everyone else. Used by whichever surface the shopper
     * actually changed the zip on. */
    commit: function (value) {
      write(value);
      announce(value);
    },
    /* Store it quietly. Used when a surface merely observed what PIM already
     * decided, so the other surface catches up without a change being claimed. */
    observe: function (value) {
      var current = read();
      if (current && current.city === value.city && current.zip === value.zip) return;
      write(value);
      announce(value);
    }
  };
})();

/* The delivery tier: Same-Day, 1-Day, 2-Day or 3-Day, from one cart-estimate answer.
 *
 * Decided here, in the theme, so the product page and the cart use one rule. A day is
 * a calendar day from now to the delivery date, counted in the shopper's own zone,
 * which is the zone the printed date is formatted in, so the badge can never say
 * something the date beside it does not. The same item wears 3-Day on a Saturday and
 * 1-Day on a Monday, and that is correct rather than a defect.
 *
 * The endpoint never errors. An unknown SKU comes back 200 with a plausible date, so
 * the tier is a positive claim that has to be earned: every gate below must hold or
 * the answer is null and no badge is drawn. Freight, backorder and unrouted all fail
 * here. docs/plans/2026-09-12-delivery-badges.md, section 3.
 */
(function () {
  var store = window.apsDelivery;
  if (!store) return;
  var LABELS = { 'same-day': 'Same-Day', '1-day': '1-Day', '2-day': '2-Day', '3-day': '3-Day' };

  function dayOf(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime(); }

  function tier(data) {
    if (!data || !data.delivery_estimate) return null;
    var options = data.shipping_options || {};
    if (data.in_stock !== true) return null;
    if (!data.warehouse_id) return null;
    if (options.shipping !== 'parcel') return null;
    if (options.hasBackorder) return null;
    if (data.backorder_handling !== null && data.backorder_handling !== undefined) return null;
    var when = new Date(data.delivery_estimate);
    if (isNaN(when.getTime())) return null;
    var days = Math.round((dayOf(when) - dayOf(new Date())) / 86400000);
    if (days === 0) return data.same_day && data.same_day.length ? 'same-day' : null;
    if (days === 1) return '1-day';
    if (days === 2) return '2-day';
    if (days === 3) return '3-day';
    return null;
  }

  /* One SKU, quantity one, the shopper's stored zip or none. With no zip PIM resolves
   * the destination from the caller's IP, the same as the header's first visit. The
   * body is the one PIM's module sends, so the two share an answer.
   * options go to apsEstimate.request. */
  function estimate(sku, channel, options) {
    var body = { cart: {}, current: {}, channel: Number(channel) || 16 };
    body.cart[sku] = 1;
    body.current[sku] = 1;
    var zip = '';
    try { zip = localStorage.getItem('inYourHandsZip') || ''; } catch (e) {}
    if (zip) body.zip = zip;
    return window.apsEstimate.request(body, options);
  }

  /* The same question asked straight at PIM, no sharing and no cache: the request the
   * cart promise sync has always made, kept unchanged on purpose. */
  function estimateDirect(sku, channel) {
    var body = { cart: {}, current: {}, channel: Number(channel) || 16 };
    body.cart[sku] = 1;
    body.current[sku] = 1;
    var zip = '';
    try { zip = localStorage.getItem('inYourHandsZip') || ''; } catch (e) {}
    if (zip) body.zip = zip;
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 6000);
    return fetch(window.apsEstimate.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal: controller.signal
    })
      .then(function (r) { clearTimeout(timer); return r.ok ? r.json() : null; })
      .catch(function () { clearTimeout(timer); return null; });
  }

  /* The instant this answer's cutoff passes, from order_in, or null. PIM sends the
   * countdown rather than the instant, so it is pinned to the clock here, once, when
   * the answer arrives. After it the same SKU answers a day later: same-day becomes
   * next day, 1-Day becomes 2-Day. Anything that shows or records a promise re-asks at
   * this instant rather than letting a stale one sit. Capped at thirty six hours: on a
   * Saturday night PIM counts down to a Sunday or Monday cutoff, sixteen hours out, and
   * that has to be kept; a longer countdown than that is not a real cutoff. */
  function cutoffAt(data) {
    var o = data && data.order_in;
    if (!o || typeof o.hours !== 'number') return null;
    var ms = (o.hours * 60 + (o.minutes || 0)) * 60000;
    if (ms <= 0 || ms > 36 * 3600000) return null;
    return Date.now() + ms;
  }

  store.tier = tier;
  store.tierLabel = function (t) { return LABELS[t] || ''; };
  store.estimate = estimate;
  store.estimateDirect = estimateDirect;
  store.cutoffAt = cutoffAt;
})();

/* The promise shown, recorded on the cart.
 *
 * Nothing on this storefront has ever persisted what a shopper was promised, so the
 * hit rate could never be measured, and a checkout function cannot call PIM, so the
 * date has to already be in the cart for one to read. This writes one order-level
 * cart attribute, delivery_promise, a JSON map keyed by SKU:
 *
 *   { "PSU-175834": { "tier": "2-day", "date": "2026-09-16",
 *                     "label": "Wednesday, Sep 16", "zip": "78704",
 *                     "warehouse": 170, "cutoff": "2026-09-14T19:00:00Z",
 *                     "seen": "2026-09-14T15:19:02Z" } }
 *
 * warehouse is PIM's routing pick, the location it expects the order to ship from and
 * the one the date was computed for; a number, named in PIM. Dylan, 2026-09-14: held on
 * the order so the promised ship-from can be set beside the actual one, which is the
 * measurement PoolZoom found its promises most often miss on.
 *
 * A second attribute, delivery_promise_summary, says the same thing in one readable line
 * per SKU for whoever opens the order in the admin. The checkout function reads only the
 * JSON; the summary is for people.
 *
 * An order-level attribute, not a line item property, on purpose: a property is per
 * line and splits lines, so two adds of the same variant with different promises
 * would become two cart lines, and only the buy box could carry one. An attribute
 * never splits a line and one write covers every add path, because it is keyed on
 * what is in the cart rather than on how it got there.
 *
 * Every answer the page sees is recorded, badge or not, including "no date" for a
 * SKU PIM cannot route; a line with no promise is a data point too, and the
 * checkout function needs to know there is none rather than guess. The write
 * happens after the add has already succeeded and after the cart page has already
 * painted its dates, so nothing the shopper waits on gets slower.
 * docs/plans/2026-09-12-delivery-badges.md, section 6.
 */
(function () {
  var store = window.apsDelivery;
  if (!store) return;
  var KEY = 'apsPromise';
  var ATTR = 'delivery_promise';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function cache() {
    var map;
    try { map = JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { map = {}; }
    /* An answer whose cutoff has passed is not an answer any more. Dropping it here
       means the next sync asks again rather than re-writing the stale promise. */
    var now = Date.now();
    Object.keys(map).forEach(function (sku) {
      var c = map[sku] && map[sku].cutoff;
      if (c && Date.parse(c) <= now) delete map[sku];
    });
    return map;
  }
  function keep(map) {
    try { sessionStorage.setItem(KEY, JSON.stringify(map)); } catch (e) {}
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function currentZip() {
    var place = store.read();
    if (place && place.zip) return place.zip;
    try { return localStorage.getItem('inYourHandsZip') || ''; } catch (e) { return ''; }
  }

  /* A special order's record. No date, on purpose: the storefront promised a lead time,
     Typically ships within N days, and never a delivery date, so the checkout function, which renames
     only when every line carries a date, leaves the shipping options with their own names.
     No cutoff either, so the entry is not dropped at PIM's clock and re-asked; the lead
     time does not roll forward at a cutoff. snippets/aps-special-order.liquid. */
  function recordLead(sku, days) {
    if (!sku || !(days > 0)) return;
    var map = cache();
    map[sku] = { tier: null, date: null, label: null, lead: days, zip: currentZip(), warehouse: null,
                 seen: new Date().toISOString().replace(/\.\d{3}Z$/, 'Z'), cutoff: null };
    keep(map);
  }
  function forget(sku) {
    var map = cache();
    delete map[sku];
    keep(map);
  }

  /* One answer for one SKU becomes one record. The routed split is the cart's:
     a warehouse, or a backorder with a number of days, means PIM stands behind
     the date; anything else is a date it cannot, and is recorded as no date. */
  function record(sku, data) {
    if (!sku) return;
    var entry = { tier: null, date: null, label: null, zip: currentZip(), warehouse: null,
                  seen: new Date().toISOString().replace(/\.\d{3}Z$/, 'Z'), cutoff: null };
    if (data && data.warehouse_id) entry.warehouse = data.warehouse_id;
    var at = store.cutoffAt(data);
    if (at) entry.cutoff = new Date(at).toISOString().replace(/\.\d{3}Z$/, 'Z');
    if (data && data.delivery_estimate) {
      var routed = data.warehouse_id || typeof data.backorder_handling === 'number';
      var when = new Date(data.delivery_estimate);
      if (routed && !isNaN(when.getTime())) {
        entry.tier = store.tier(data);
        entry.date = when.getFullYear() + '-' + pad(when.getMonth() + 1) + '-' + pad(when.getDate());
        entry.label = when.toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric' });
      }
    }
    var map = cache();
    map[sku] = entry;
    keep(map);
  }

  function readCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* Which of the cart's lines are special orders, and their lead times, as a map of SKU to
     days. cart.js carries no metafields, and an add can come from any surface, so the theme
     is asked directly: sections/aps-lead-times.liquid renders the map for the current cart
     through the Section Rendering API. null when it cannot be read, which leaves the sync
     working exactly as it did before special orders existed. */
  var LEAD_SECTION = 'aps-lead-times';
  function readLeads() {
    return fetch(root + '?sections=' + LEAD_SECTION)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var html = data && data[LEAD_SECTION];
        var m = html && /<script[^>]*data-aps-leads[^>]*>([\s\S]*?)<\/script>/.exec(html);
        return m ? JSON.parse(m[1]) : null;
      })
      .catch(function () { return null; });
  }

  var inFlight = false;
  var again = false;
  var lastWritten = null;
  var wake = null;
  var SUMMARY = 'delivery_promise_summary';

  /* One line per SKU, for the order page in the admin. */
  function summarize(entries) {
    return Object.keys(entries).map(function (sku) {
      var e = entries[sku];
      if (e.lead) {
        return sku + ': special order, typically ships within ' + e.lead + (e.lead === 1 ? ' day' : ' days') + (e.zip ? ', to ' + e.zip : '');
      }
      var parts = [sku + ': ' + (e.tier ? store.tierLabel(e.tier) : (e.date ? 'no badge' : 'no promise'))];
      if (e.label) parts.push(e.label);
      // PIM's location id, the number in pim.poolzoom.com/locations/<id>. Named so the team
      // reads it as a PIM location rather than a bare number. Dylan, 2026-09-14.
      parts.push(e.warehouse ? 'from PIM location id ' + e.warehouse : 'unrouted');
      if (e.zip) parts.push('to ' + e.zip);
      return parts.join(', ');
    }).join('\n');
  }

  /* Re-sync the moment the earliest cutoff among the cart's promises passes, so the
     attribute never carries a same-day or 1-Day promise that the clock has already
     taken away. The cache drops the expired entries and the sync asks again. */
  function wakeAtCutoff(entries) {
    clearTimeout(wake);
    var soonest = null;
    Object.keys(entries).forEach(function (sku) {
      var c = entries[sku] && entries[sku].cutoff && Date.parse(entries[sku].cutoff);
      if (c && (!soonest || c < soonest)) soonest = c;
    });
    if (!soonest) return;
    var delay = Math.max(1500, soonest - Date.now() + 1500);
    wake = setTimeout(sync, Math.min(delay, 36 * 3600000));
    store.nextPromiseRefresh = new Date(Date.now() + delay).toISOString();
  }

  /* Bring the attribute in step with the cart. Only SKUs in the cart are written;
     one already answered this session costs nothing, an unseen one costs a single
     request. The write is skipped when nothing changed, which is what stops a
     cart page and an add from writing the same map twice. */
  function sync() {
    if (inFlight) { again = true; return; }
    inFlight = true;
    Promise.all([readCart(), readLeads()]).then(function (both) {
      var cart = both[0];
      var leads = both[1];
      if (!cart || !cart.items) return;
      var skus = [];
      cart.items.forEach(function (item) {
        if (item.sku && skus.indexOf(item.sku) < 0) skus.push(item.sku);
      });
      /* Special orders first. A line that is one gets its lead time record, replacing any PIM
         answer the session holds for it; a line that was one and no longer is, because stock
         came in or the lead time was cleared, loses its record and is asked about below. */
      if (leads) {
        skus.forEach(function (sku) {
          var days = leads[sku] || 0;
          var held = cache()[sku];
          if (days > 0) {
            if (!held || held.lead !== days) recordLead(sku, days);
          } else if (held && held.lead) {
            forget(sku);
          }
        });
      }
      var map = cache();
      var missing = skus.filter(function (sku) { return !map[sku]; });
      return Promise.all(missing.map(function (sku) {
        return store.estimateDirect(sku, 16).then(function (data) { record(sku, data); });
      })).then(function () {
        var fresh = cache();
        var out = {};
        skus.forEach(function (sku) { if (fresh[sku]) out[sku] = fresh[sku]; });
        var value = skus.length ? JSON.stringify(out) : '';
        if (value === lastWritten) return;
        var current = cart.attributes && cart.attributes[ATTR];
        if ((current || '') === value) { lastWritten = value; return; }
        var attributes = {};
        attributes[ATTR] = value;
        attributes[SUMMARY] = skus.length ? summarize(out) : '';
        wakeAtCutoff(out);
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        }).then(function (r) { if (r.ok) lastWritten = value; });
      });
    }).catch(function () {}).then(function () {
      inFlight = false;
      if (again) { again = false; sync(); }
    });
  }

  /* Every add path the theme has announces itself with this event, carrying a
     promise that settles when the mutation lands. Wait on it, capped, then sync;
     reading the cart before it settles reads the cart as it was. */
  document.addEventListener('shopify:cart:lines-update', function (event) {
    var settled = event.promise && typeof event.promise.then === 'function'
      ? Promise.race([event.promise, new Promise(function (r) { setTimeout(r, 4000); })])
      : Promise.resolve();
    settled.catch(function () {}).then(function () { setTimeout(sync, 50); });
  });

  store.recordPromise = record;
  store.recordLead = recordLead;
  store.syncPromise = sync;
})();

/* The product page badge.
 *
 * The badge is the theme's own element beside PIM's module, not inside it, because the
 * module's answer never reaches the page as data: the theme only sees its DOM. So the
 * theme asks the same question itself, one request per product view in parallel with
 * the module's own, and fills the badge when the answer passes the gates. The variant
 * script in snippets/aps-delivery.liquid re-points the badge on every remount and
 * announces it. A zip change from the panel's own form does not remount; see below.
 */
(function () {
  var store = window.apsDelivery;
  var badge = document.querySelector('[data-deliv-tier]');
  if (!store || !badge) return;
  var label = badge.querySelector('[data-deliv-tier-label]');
  var seq = 0;
  var asked = null;

  /* A zip can change two ways, and they reach here differently. The header chip
     commits the zip and the snippet remounts the module, which announces a variant
     event. The panel's own zip form is PIM's: the module re-fetches by itself, the
     snippet only observes the new place, and nothing remounts, so the variant event
     never fires. That was the bug Dylan found on 2026-09-14: 90210 to 78261 in the
     panel moved the promise from 2-Day to 1-Day and the badge stayed. So the badge
     also listens to the place announcement itself, and asks again whenever the SKU
     and zip it last asked about are not the ones on the page now. The pair is the
     key, so a header change that arrives twice, once as the place and once as the
     remount, costs one request rather than two. */
  function currentZip() {
    try { return localStorage.getItem('inYourHandsZip') || ''; } catch (e) { return ''; }
  }

  /* PIM's module asks the same question for the same SKU and zip on every mount and
     remount, so the badge waits for that request and shares it rather than asking
     twice. The badge sits inside the module's panel, which stays hidden until the
     module renders, so the wait shows nothing the shopper could see. If the module
     never asks, the badge asks for itself when the wait runs out. The cutoff timer
     asks at once: no remount happens then. */
  var PEER_WAIT = 4000;

  function fill(force, atCutoff) {
    var sku = badge.getAttribute('data-sku');
    var key = sku + '|' + currentZip();
    if (!force && key === asked) return;   // same SKU, same zip: the answer on screen stands
    asked = key;
    badge.hidden = true;
    badge.removeAttribute('data-tier');
    if (!sku || badge.getAttribute('data-available') !== 'true') return;
    /* A special order wears no badge and PIM is not asked: the lead time on the line under the
       heading is the promise. It is recorded so the cart attribute says so from the first add. */
    var lead = parseInt(badge.getAttribute('data-lead'), 10) || 0;
    if (lead > 0) {
      ++seq;
      clearTimeout(wake);
      if (store.recordLead) store.recordLead(sku, lead);
      return;
    }
    var mine = ++seq;
    var peer = !atCutoff && document.getElementById('pim-in-your-hands') ? PEER_WAIT : 0;
    store.estimate(sku, badge.getAttribute('data-channel'), { peerWait: peer }).then(function (data) {
      if (mine !== seq) return;   // a newer variant or zip superseded this answer
      if (store.recordPromise) store.recordPromise(sku, data);
      var t = store.tier(data);
      if (!t) return;
      // FREE leads the tier exactly when the line ships free; the snippet decides that
      // from the variant price against the threshold, the same test as the heading.
      var free = badge.getAttribute('data-free') === 'true';
      label.textContent = (free ? 'FREE ' : '') + store.tierLabel(t);
      badge.setAttribute('data-tier', t);
      badge.hidden = false;
      /* And ask again the moment the cutoff passes, so a page left open does not
         keep saying Same-Day or 1-Day after the clock has moved the promise. */
      var at = store.cutoffAt(data);
      clearTimeout(wake);
      if (at) wake = setTimeout(function () { fill(true, true); }, at - Date.now() + 1500);
    });
  }
  var wake = null;

  document.addEventListener('aps:delivery:variant', function () { fill(false); });
  document.addEventListener(store.event, function () { fill(false); });
  fill(true);
})();

/* The header chip.
 *
 * Paints from storage on the first frame when there is something stored, so the
 * common case costs no request at all. A first-time visitor has nothing, and one
 * empty-cart call resolves their place from their IP; the answer is stored, so it
 * is one call per visitor rather than one per page.
 */
(function () {
  var store = window.apsDelivery;
  var chips = document.querySelectorAll('[data-aps-deliv]');
  if (!store || !chips.length) return;

  function paint(value) {
    for (var i = 0; i < chips.length; i++) {
      var city = chips[i].querySelector('[data-aps-deliv-city]');
      if (!city) continue;
      city.textContent = value.city;
      city.removeAttribute('data-aps-deliv-pending');
    }
  }

  function open(chip, yes) {
    var pop = chip.querySelector('[data-aps-deliv-pop]');
    var trigger = chip.querySelector('[data-aps-deliv-trigger]');
    pop.hidden = !yes;
    trigger.setAttribute('aria-expanded', yes ? 'true' : 'false');
    if (yes) {
      var current = store.read();
      var input = chip.querySelector('[data-aps-deliv-input]');
      input.value = current && current.zip ? current.zip : '';
      chip.querySelector('[data-aps-deliv-note]').hidden = true;
      setTimeout(function () { input.focus(); input.select(); }, 20);
    }
  }

  function closeAll() {
    for (var i = 0; i < chips.length; i++) open(chips[i], false);
  }

  function save(chip) {
    var input = chip.querySelector('[data-aps-deliv-input]');
    var note = chip.querySelector('[data-aps-deliv-note]');
    var save_btn = chip.querySelector('[data-aps-deliv-save]');
    var zip = (input.value || '').replace(/[^0-9]/g, '');

    // Five digits before it leaves the page. PIM answers a malformed zip with a
    // real looking estimate and a null city rather than an error, so this is the
    // only place the shopper can be told they mistyped.
    if (zip.length !== 5) {
      note.textContent = 'Enter a five digit zip code.';
      note.hidden = false;
      input.focus();
      return;
    }

    save_btn.disabled = true;
    store.resolve(zip, chip.getAttribute('data-aps-deliv') || 16).then(function (value) {
      save_btn.disabled = false;
      if (!value) {
        note.textContent = 'That zip was not recognized. Check it and try again.';
        note.hidden = false;
        return;
      }
      store.commit(value);
      paint(value);
      closeAll();
    });
  }

  for (var i = 0; i < chips.length; i++) {
    (function (chip) {
      chip.querySelector('[data-aps-deliv-trigger]').addEventListener('click', function (event) {
        event.preventDefault();
        var wasOpen = !chip.querySelector('[data-aps-deliv-pop]').hidden;
        closeAll();
        open(chip, !wasOpen);
      });
      chip.querySelector('[data-aps-deliv-save]').addEventListener('click', function () { save(chip); });
      chip.querySelector('[data-aps-deliv-input]').addEventListener('keydown', function (event) {
        if (event.key === 'Enter') { event.preventDefault(); save(chip); }
      });
    })(chips[i]);
  }

  document.addEventListener('click', function (event) {
    for (var i = 0; i < chips.length; i++) {
      if (chips[i].contains(event.target)) return;
    }
    closeAll();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  // The product panel resolves a place too, and announces it. Repaint, never
  // re-announce: that is what keeps the two from talking in circles.
  document.addEventListener(store.event, function (event) {
    if (event.detail && event.detail.city) paint(event.detail);
  });

  var known = store.read();
  if (known) {
    paint(known);
  } else {
    var channel = chips[0].getAttribute('data-aps-deliv') || 16;
    store.resolve(null, channel).then(function (value) {
      if (!value) return;   // fail closed: the prompt stays, no place is invented
      store.commit(value);
      paint(value);
    });
  }
})();
